import { FC, useCallback, useRef, useState } from 'react';

import classNames from 'classnames';

import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../utils/breakpoint';

import { Pressable } from '../../shared/ui';

import { BonusInfoLabelToolTip } from './bonus-info-label-tooltip';

interface ToolDescriptionIconProps {
  description: string;
  className?: string;
}

type TooltipPosition = {
  top: number;
  left: number;
};

export const ToolDescriptionIcon: FC<ToolDescriptionIconProps> = ({ description, className }) => {
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition | null>(null);
  const iconRef = useRef<HTMLButtonElement>(null);
  const breakpoint = useBreakpoint();

  const handleToggle = useCallback(() => {
    if (tooltipPosition) {
      setTooltipPosition(null);
      return;
    }

    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: breakpoint > Breakpoint.Lg ? rect.bottom + 8 : rect.top - 70,
        left: breakpoint > Breakpoint.Lg ? rect.left + rect.width / 2 : rect.left,
      });
    }
  }, [tooltipPosition, breakpoint]);

  return (
    <Pressable
      aria-label="Описание инструмента"
      ref={iconRef}
      onClick={handleToggle}
      className={classNames('ml-1 rounded-full text-ink-subtle flex items-center justify-center', className)}
    >
      <div className="bg-ink-subtle rounded-full w-[12px] h-[12px] text-micro text-white text-center leading-[12px]">
        ?
      </div>
      {tooltipPosition && (
        <div className="z-popover" style={{ position: 'fixed', top: tooltipPosition.top, left: tooltipPosition.left }}>
          <BonusInfoLabelToolTip text={description} onClose={() => setTooltipPosition(null)} />
        </div>
      )}
    </Pressable>
  );
};
